module.exports = __webpack_public_path__ + "static/media/base_impact_civic.be755163.png";